import { z } from "zod";

const Coordinate = z.tuple([z.number(), z.number()]);

const documentElement = z.object({
  id: z.string(),
  parentId: z.string(),
  stringContent: z.string(),
  isRelevantJudgement: z.boolean().nullable(),
  isRelevantConfidence: z.enum(["high", "medium", "low"]).nullable(),
  contentTokenCount: z.number().nullable(),
});

const pdfElement = documentElement.extend({
  startPageNumber: z.number(),
  boundingBox: z.tuple([Coordinate, Coordinate, Coordinate, Coordinate]).nullable(),
  span: z.tuple([z.number(), z.number()]),
});

const pdfTableCell = z.object({
  content: z.union([z.string(), z.number()]),
  boundingBox: z.tuple([Coordinate, Coordinate, Coordinate, Coordinate]).nullable(),
});

export const pdfTable = pdfElement.extend({
  headers: z.array(z.string()).nullable(),
  cells: z.array(z.array(pdfTableCell)).nullable(),
});

export const pdfSection = pdfElement;

export const pdfElementT = z.union([pdfSection, pdfTable]);

const pdfWord = z.object({
  id: z.string(),
  stringContent: z.string(),
  span: z.tuple([z.number(), z.number()]),
  boundingBox: z.tuple([Coordinate, Coordinate, Coordinate, Coordinate]).nullable(),
});

const pdfPage = z.object({
  pageNumber: z.number(),
  width: z.number(),
  height: z.number(),
  words: z.array(pdfWord),
});

export const pdfDocument = z.object({
  id: z.string(),
  elements: z.array(pdfElementT),
  filename: z.string(),
  markdownContent: z.string(),
  pages: z.array(pdfPage),
  widths: z.array(z.number()),
  heights: z.array(z.number()),
  images: z.array(z.string()).nullable(),
});
